export default {"src":"/_next/static/media/no_events.b236f3d2.svg","height":151,"width":221};